module.exports = __webpack_public_path__ + "static/innout-burger-694f7107d3cf6179001e00a5978d1e55.jpg";